// extracted by mini-css-extract-plugin
export default {"BoxStepInfoContainer":"BoxInfo_BoxStepInfoContainer__Rrhvh","TextoInfo":"BoxInfo_TextoInfo__MMIaX"};